import { useEffect } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { useCheckRoles } from './hooks';

/**
 * Componente para ruteos con autorización requerida. Si ningún rol del usuario logueado corresponde
 * a algún rol de allowedRoles, se redirecciona a la url raíz.
 */
function PrivateRoute({ component: Component, allowedRoles = [], isAllowed = null, ...rest }) {
  const history = useHistory();
  const hasRole = useCheckRoles(allowedRoles);
  const allowed = isAllowed === null ? hasRole : isAllowed;

  useEffect(() => {
    if (!allowed) history.push('/');
  }, [allowed, history]);

  return allowed && <Route {...rest} />;
}

export default PrivateRoute;
